let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("C5mB9")).then(() => parcelRequire('hox2O'));